import './Counter.css';
import React from 'react';
var Counter = function Counter(_ref) {
  var value = _ref.value,
    countTemplate = _ref.countTemplate,
    onChange = _ref.onChange,
    limit = _ref.limit;
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("button", {
    className: "count__btn",
    disabled: value - 1 === 0,
    onClick: function onClick() {
      return onChange(value - 1);
    }
  }, "\u2013"), /*#__PURE__*/React.createElement("div", {
    className: "count__value"
  }, countTemplate.replace("{x}", "".concat(value))), /*#__PURE__*/React.createElement("button", {
    className: "count__btn",
    disabled: value === limit,
    onClick: function onClick() {
      return onChange(value + 1);
    }
  }, "+"));
};
export default Counter;
var commonStyles = "ck084v1";